import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== pwd2) { toast.error("Les mots de passe ne correspondent pas"); return; }
    if (pwd.length < 6) { toast.error("6 caractères minimum"); return; }
    if (!token) { toast.error("Lien invalide"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      setDone(true);
      toast.success("Mot de passe réinitialisé");
      setTimeout(() => navigate("/auth"), 2500);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-80px)] flex items-center justify-center px-4 py-12 bg-[#F9FAF6]" data-testid="reset-password-page">
      <div className="w-full max-w-md bg-white border border-[#E5EAE5] rounded-3xl p-8 lg:p-10">
        <h1 className="text-3xl font-black tracking-tighter">Nouveau mot de passe</h1>
        <p className="text-[#4B634B] mt-1 text-sm">Choisissez un nouveau mot de passe sécurisé.</p>

        {done ? (
          <div className="mt-8 text-center" data-testid="reset-password-success">
            <CheckCircle2 className="w-16 h-16 text-[#7AC143] mx-auto mb-4" />
            <p className="font-semibold">Mot de passe mis à jour.</p>
            <p className="text-[#4B634B] text-sm mt-2">Redirection vers la page de connexion...</p>
            <Link to="/auth" className="inline-block mt-4 text-[#7AC143] font-semibold underline">Se connecter maintenant</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-8">
            <div>
              <Label htmlFor="p1">Nouveau mot de passe</Label>
              <Input id="p1" type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} required minLength={6} data-testid="reset-password-input" />
            </div>
            <div>
              <Label htmlFor="p2">Confirmer le mot de passe</Label>
              <Input id="p2" type="password" value={pwd2} onChange={(e) => setPwd2(e.target.value)} required minLength={6} data-testid="reset-password-confirm" />
            </div>
            <Button type="submit" disabled={loading} data-testid="reset-submit" className="w-full bg-[#7AC143] hover:bg-[#67BC2A] text-white rounded-full py-6 font-bold">
              {loading ? "Mise à jour..." : "Réinitialiser"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
